/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAraasRoomVideoCredentialsFromJSON(json) {
    return StreemApiAraasRoomVideoCredentialsFromJSONTyped(json, false);
}
export function StreemApiAraasRoomVideoCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'webSocketUri': !exists(json, 'web_socket_uri') ? undefined : json['web_socket_uri'],
    };
}
export function StreemApiAraasRoomVideoCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'web_socket_uri': value.webSocketUri,
    };
}
//# sourceMappingURL=StreemApiAraasRoomVideoCredentials.js.map